export const subtitles = {
    "1": {
        "startTime": 1.35,
        "endTime": 4.23,
        "transcript": "Cali naspaaqaa.",
        "translation": "Please try again."
    },
    "2": {
        "startTime": 4.52,
        "endTime": 8.71,
        "transcript": "Naspaalua qanqerlii. Tua-llu?",
        "translation": "Let me try speaking. Can you hear me?"
    },
    "3": {
        "startTime": 36.47,
        "endTime": 40.54,
        "transcript": "Kitak' tua-i ellangellemni qanruyutellemnek.",
        "translation": "Now, let me speak of the traditional wisdom when I was growing up."
    },
    "4": {
        "startTime": 40.552,
        "endTime": 53.741,
        "transcript": "Ellangellruunga pavani yuilqumi nunangqerraqluta wall' uani Tagyaram paingani nunangqerraqluta kiimeta.",
        "translation": "I grew up where we had a settlement in the wilderness inland, or we had our own settlement at the mouth of Tagyaraq."
    },
    "5": {
        "startTime": 54.171,
        "endTime": 66.104,
        "transcript": "Kiagmi tau͡gaam neqlillerni tamaa-i nasaurluullemni tuaten ayuqellruukut. Pavani yuilqumi uksuarmi uitaaqluta yugtaunani elatvut.",
        "translation": "But in the summer, we were be at the fish camps when I was a girl. We would stay in the wilderness inland in the fall with no one around us."
    },
    "6": {
        "startTime": 66.207,
        "endTime": 71.285,
        "transcript": "Uani-ll' call' uksumi Tagyarami yugtaunani elatvut.",
        "translation": "And downriver in Tagyaraq during the winter, there was no one around us."
    },
    "7": {
        "startTime": 71.29,
        "endTime": 76.934,
        "transcript": "Tau͡gaam neqlillernun ayagaqamta nutaan yugnek tangengaqluta.",
        "translation": "But when we went to fish camps, we'd finally start seeing people."
    },
    "8": {
        "startTime": 77.565,
        "endTime": 86.554,
        "transcript": "Tua-ll' maurlumni wii uitalua maurluma anglicaraqnganga, maurluugma anglicaraqnganga.",
        "translation": "Then I would stay with my grandmother because she raised me, because my grandparents raised me."
    },
    "9": {
        "startTime": 86.775,
        "endTime": 95.198,
        "transcript": "Ukugnek tau͡gken arnagnek cali ilalua. Ilakluta tua-i.",
        "translation": "However, I had two other women with me. We were a family."
    },
    "10": {
        "startTime": 95.38,
        "endTime": 107.747,
        "transcript": "Tua-i-ll' taum maurlurma qanrut'laraakut, unuakumi-llu inerqularaakut maktaqamta nakukut'laasqevkenata, nakukuteksaunata pisqelluta.",
        "translation": "Then my grandmother would tell us, and she would admonish us in the morning when we wake up against fighting, that we shouldn't fight."
    },
    "11": {
        "startTime": 107.755,
        "endTime": 117.655,
        "transcript": "Tua-i ilarraquralriani wangkuta tuani enem iluani ilarraquralriani nakukucuunata ilakellruukut.",
        "translation": "We small family, we small family in that house did not fight."
    },
    "12": {
        "startTime": 117.655,
        "endTime": 124.888,
        "transcript": "Waten tua-i pilaraakut: caqcaaralaasqelluta tau͡gaam ikayuqu'urluta nakukuteksaunata.",
        "translation": "She would tell us this: we should always be busy and help each other without fighting."
    },
    "13": {
        "startTime": 125.01,
        "endTime": 134.832,
        "transcript": "Tua-i-ll' tamaavet ayiimta yugnun waten call' pilaraanga unuakumi anqata'arqama:",
        "translation": "Then when we went to populated places, she would also say this to me when I was going to go out in the morning:"
    },
    "14": {
        "startTime": 134.837,
        "endTime": 146.57,
        "transcript": "Kitaki-gguq nakukekatnga, qakemkut naanguaqumta-llu nakukekatnga qimakilii. Akinauryaqunii-gguq.",
        "translation": "If they pick on me, and if they pick on me as we're playing, that I should run away. She told me not to retaliate."
    },
    "15": {
        "startTime": 147.23,
        "endTime": 160.106,
        "transcript": "Tuamta-ll' waten call' pilaraanga: yuum-gguq pingraanga akinauryaqunaku, tau͡gaam-gguq ilanka kenekluki, kenkurluki. Kenkurautelalta-gguq.",
        "translation": "Then she would also tell me this: no matter what a person does to me, I should not retaliate, but always treat my peers with love. She told us to treat each other with love."
    },
    "16": {
        "startTime": 160.116,
        "endTime": 163.682,
        "transcript": "Ilaput-llu-gguq tamalkuita kenkurluki.",
        "translation": "She also said to treat all of our peers with love."
    },
    "17": {
        "startTime": 164.173,
        "endTime": 173.417,
        "transcript": "Tua-i tamaa-i nasaurluullemni, nasaurluullemteńi qalarut'laraakut qaillun ayuqellerkamteńek ernerpak.",
        "translation": "Back when I was a girl, when we were girls, she would talk to us about how we should behave all day."
    },
    "18": {
        "startTime": 173.423,
        "endTime": 179.101,
        "transcript": "Taumek alikellruarput wangkuta nunurnganata qalarut'laakut.",
        "translation": "That's why we feared her since she spoke to us as if scolding us."
    },
    "19": {
        "startTime": 179.457,
        "endTime": 187.846,
        "transcript": "Qanruyutni nall'artenritqerqamteggu taum muarlurma nunurngatpiarluta qanpagalluta qalarutaqluta.",
        "translation": "When we disobeyed her traditional wisdom, my grandmother would speak to us very sternly as if scolding us."
    },
    "20": {
        "startTime": 187.89,
        "endTime": 194.968,
        "transcript": "Taumek alikellruarput qanruyutiin uniurtaallerkaa.",
        "translation": "That's why we were afraid to go against her traditional wisdom."
    },
    "21": {
        "startTime": 195.19,
        "endTime": 203.99,
        "transcript": "Tua-i tuaten kenkutesqelluta alerqualaraakut kenkuquraasqelluta, ilaput-llu nakukeksaunaki.",
        "translation": "The would instruct us to treat each other with love like that, and not to pick on our peers."
    },
    "22": {
        "startTime": 204.195,
        "endTime": 211.062,
        "transcript": "Yuum-llu pingraakut cali akilaasqevkenaku.",
        "translation": "And no matter what a person does to us, we should not retaliate."
    },
    "23": {
        "startTime": 211.327,
        "endTime": 220.567,
        "transcript": "Tau͡gaam waten piaqluta: caliqcaaralaalta-gguq, ullagtaarutevkenata-llu-gguq.",
        "translation": "But they would say this to us: we shoudl always be busy, and not visit each other too often."
    },
    "24": {
        "startTime": 220.874,
        "endTime": 232.441,
        "transcript": "Ullagtaaruskumta-gguq atam yugnun cangayuutekamteńun tekitniartukut. Ullagtaarupakarluta-gguq cangayuutekamteńun tekiciiqukut.",
        "translation": "She said that if we visit other people too often, we'll eventually be offended. She said that if we visit too often, we'll eventually be offended."
    },
    "25": {
        "startTime": 232.638,
        "endTime": 245.994,
        "transcript": "Tua-i-llu-gguq tuaten ceńirtaatukumta ullagtaarucukumta caurailngarciqukut-gguq. Calillerkamteńi-gguq ak'a caarkaput caurailngarciqaput.",
        "translation": "Then she said that if we visit too often, we will lack things. She said that when we will lack things when we should have worked."
    },
    "26": {
        "startTime": 246.813,
        "endTime": 253.207,
        "transcript": "Tuamta-llu-gguq calqurraq-gguq arnarrlainaungamta",
        "translation": "Then she talked about grass since we were all women"
    },
    "27": {
        "startTime": 253.633,
        "endTime": 262.86,
        "transcript": "Tamaani ellangellemni wiinga caranglluut makut can'get yuut teguyaraqellruit tupigturluki.",
        "translation": "Back when I was growing up, people always took grass and wove them."
    },
    "28": {
        "startTime": 264.76,
        "endTime": 268.905,
        "transcript": "Neqauteteng caquliluki kiagmi.",
        "translation": "They made fish containers in the summer."
    },
    "29": {
        "startTime": 269.408,
        "endTime": 275.372,
        "transcript": "Taryaqviit-llu inglukeggluki iitallernek, iitallernek-llu caquluki.",
        "translation": "And they would pair king salmon with tall cottongrass, then cover them with tall cottongrass."
    },
    "30": {
        "startTime": 275.386,
        "endTime": 283.242,
        "transcript": "Tamaa-i-gguq cumercuilkumta caqatallerput nallunaiciiquq. Yaaken yaaqlimteńek iliiraaqluta.",
        "translation": "They said that if we do not gather, it will be clear what we would do. We would ask for things from our neighbors over there."
    },
    "31": {
        "startTime": 283.745,
        "endTime": 289.29,
        "transcript": "Inglukgutkaaramteńek iitallernek iitarcuilkumta iliiraaqluta.",
        "translation": "If we do not gather tall cottongrass to pair them with, we will ask for things."
    },
    "32": {
        "startTime": 289.679,
        "endTime": 296.879,
        "transcript": "Tua-i-gguq tamaa-i qelketailkumta iliirasteńguciqukut. Tuaten qanrut'lallruakut.",
        "translation": "She said that if we do not save things, we will be beggars. That's what she told us."
    },
    "33": {
        "startTime": 297.197,
        "endTime": 301.82,
        "transcript": "Arrsaullruukut. Ellangellemteńi cataunani.",
        "translation": "We were poor. There was nothing when we were growing up."
    },
    "34": {
        "startTime": 302.281,
        "endTime": 309.726,
        "transcript": "Tuamtell' cali pinauraakut, tua-i waten mat'um nalliinitun ayuqellrunrituq ellangellemteńi.",
        "translation": "Then she would tell us, well, it wasn't like how it is now when we were growing up."
    },
    "35": {
        "startTime": 309.82,
        "endTime": 313.198,
        "transcript": "Wii arnassagapiarurteksaicaaqua.",
        "translation": "I haven't become a very old lady yet."
    },
    "36": {
        "startTime": 313.631,
        "endTime": 322.85,
        "transcript": "Tua-i tau͡gaam ellangellemni tamakut ak'allarnun taukunun ellangama ak'allapiatun ayuqngatellrulliniut.",
        "translation": "But because I grew up around those old people, it seems they lived a very old life."
    },
    "37": {
        "startTime": 323.822,
        "endTime": 330.678,
        "transcript": "Tuaten qanrut'laraakut, qelketailkumta-gguq iliirasteńguciqukut.",
        "translation": "That's what she told us, that we'll be beggars if we do not save things."
    },
    "38": {
        "startTime": 332.248,
        "endTime": 345.788,
        "transcript": "Mingqeqataqumta-llu-gguq, tang mat'um nalliini enurnaqsugnailngurmek, mingqeqataqumta-llu-gguq qelketailkumta yaaken yaaqlimteńek yualukaramteńek iliiraciqukut.",
        "translation": "And she said that if we're going to sew, see how it's not scarce these days, if we're going to sew and we don't save things, we'll ask for thread from our neighbors over there."
    },
    "39": {
        "startTime": 346.298,
        "endTime": 357.187,
        "transcript": "Wall'u-gguq mingqutmek-llu-gguq navrarciqliukut, wall'u-gguq iliiraciqukut qelketailkumta. Tang arrsaullrutacirput.",
        "translation": "Or, she said that we might borrow or ask for a needle if we don't store things. That's how poor we were."
    },
    "40": {
        "startTime": 357.701,
        "endTime": 361.89,
        "transcript": "Taumek qanruyuteput qigcignarqellruut.",
        "translation": "That's why our traditional wisdom warranted respect."
    },
    "41": {
        "startTime": 362.204,
        "endTime": 376.18,
        "transcript": "Tua-ll' tuaten tua-i qalaruqaarluta qanrut'laraakut, kitaki-gguq neqalleruarmek tangerqumta, man'a maa-i ciuqliuguq neqalleruar.",
        "translation": "Then after telling us that, she would tell us that if we see a fish, this fish is the first thing."
    },
    "42": {
        "startTime": 376.516,
        "endTime": 387.616,
        "transcript": "Neqalleruarmek tangerqumta ciuniuqilaut-gguq ikgelkevkenaku. Iniqerluku kinerciqerluku.",
        "translation": "If we see a fish, we should welcome it without thinking it's too little. We should hang and dry it."
    },
    "43": {
        "startTime": 387.626,
        "endTime": 392.892,
        "transcript": "Tua-i-gguq tauna neqkaurciiquq iniqerluku kinerciqaqumteggu.",
        "translation": "She said that would become food if we hand and dry it."
    },
    "44": {
        "startTime": 393.299,
        "endTime": 400.488,
        "transcript": "Waten kiagmi sek'arluku-gguq neqraq ataucirraungraan agarareskilaut.",
        "translation": "In the summer like this, she said we should cut even a single fish and hang it."
    },
    "45": {
        "startTime": 400.61,
        "endTime": 405.477,
        "transcript": "Tua-i-llu-gguq kinqaku egamaarrlugarkaurciiqerput.",
        "translation": "Then she said that when it dries, we can make it into dried and boiled fish."
    },
    "46": {
        "startTime": 405.495,
        "endTime": 411.761,
        "transcript": "Tau͡gken-gguq ikgelkelluku ilangcinrilkumteńi paralut-gguq nerluku.",
        "translation": "However, she said that if we ignore it saying it's too little, worms will eat it."
    },
    "47": {
        "startTime": 411.802,
        "endTime": 423.013,
        "transcript": "Paralut caunrirluku, ciiviit anarluku paralungluku-llu tua-i neqkaunrirluni, neqkaugarkaunrirluni.",
        "translation": "Worms destroy it, flies lay eggs on it and worms infest it until it's no longer edible."
    },
    "48": {
        "startTime": 423.022,
        "endTime": 432.778,
        "transcript": "Taumek-gguq ikgelengraan ca neqalleruar qemagartaqluku pilaut. Neqkautuuq-gguq ikgelnge'rmi.",
        "translation": "That's why se said to store even a little fish. She said it becomes food even though it's not a lot."
    },
    "49": {
        "startTime": 433.116,
        "endTime": 436.26,
        "transcript": "Maa-i tuaten qanrutetuallruakut.",
        "translation": "That's what she would tell us."
    },
    "50": {
        "startTime": 436.268,
        "endTime": 444.435,
        "transcript": "Tuamta-llu pitsaqevkenani angussaagtengkumta arnarrlainaungamta",
        "translation": "Then, should we have providers, since we're all women"
    },
    "51": {
        "startTime": 444.847,
        "endTime": 450.414,
        "transcript": "Amllengrraan-gguq arnam neqkaq amrukenrilliu.",
        "translation": "Though there's a lot of food [to prepare], a woman should not be overwhelmed by it."
    },
    "52": {
        "startTime": 451.058,
        "endTime": 460.536,
        "transcript": "Tau͡gaam amrukluku-gguq tua-i picuvlagluku pinrilliu. Pinqegcaarturluku-gguq kinerciarqiliu.",
        "translation": "Instead, she said she should not do a sloppy job on it. She said she should do it well and dry it."
    },
    "53": {
        "startTime": 460.713,
        "endTime": 467.158,
        "transcript": "Maavet-llu-gguq neqallret tutmallermun pivkenaki, natmun tutmallrunrilngurmun ciqilluki.",
        "translation": "Also, she said not to dump fish guts to where people have trod, but somewhere that no one has trod."
    },
    "54": {
        "startTime": 467.22,
        "endTime": 473.22,
        "transcript": "Tangniitut-gguq neqallret maani saggluteng cailkami.",
        "translation": "She said that fish guts are an eyesore when scattered on the ground here."
    },
    "55": {
        "startTime": 473.416,
        "endTime": 478.093,
        "transcript": "Neqa-gguq piinani nangteqnarquq anrutaq piinani.",
        "translation": "She said that being without food and an empty stomach is unbearable."
    },
    "56": {
        "startTime": 478.108,
        "endTime": 481.019,
        "transcript": "Maa-i tang makut qanruyutelput.",
        "translation": "This is the traditional wisdom passed down to us."
    },
    "57": {
        "startTime": 482.087,
        "endTime": 489.548,
        "transcript": "Apqucim-gguq tamarmi naulluunam atuyunailqaa anrutam piitellra.",
        "translation": "They said that it's worse having an empty stomach than any ailment or sickness."
    },
    "58": {
        "startTime": 490.178,
        "endTime": 494.378,
        "transcript": "Taumek-gguq neqalleruar, tua-i maa-i makut qanruyuteput.",
        "translation": "That's why a fish, these are our traditional wisdom."
    },
    "59": {
        "startTime": 494.397,
        "endTime": 500.642,
        "transcript": "Taumek-gguq neqalleruar yuunguitevkenaku, assiilengraan-llu qelkurluku.",
        "translation": "That's why they said not to despise a fish, to keep it even if it's bad."
    },
    "60": {
        "startTime": 500.649,
        "endTime": 504.36,
        "transcript": "Assiilkingaitukut-gguq anrutarput piilkan.",
        "translation": "They said we won't dislike anything if our stomach is empty."
    },
    "61": {
        "startTime": 504.499,
        "endTime": 508.654,
        "transcript": "Maa-i makut qanruyuteput ayagyuallemteńi.",
        "translation": "These are the traditional wisdom passed down to us when we were young."
    },
    "62": {
        "startTime": 509.649,
        "endTime": 516.483,
        "transcript": "Tuaten-llu tua-i neqalleruar sagcetevkenaku, tutmallrunrilngurmun egtesqelluku.",
        "translation": "They also told us not to scatter food waste, but to throw it away where people have not trod."
    },
    "63": {
        "startTime": 516.827,
        "endTime": 522.127,
        "transcript": "Caallugkuarrarput-llu neqlikumta tutmallrunrilngurmun egtesqelluku.",
        "translation": "And if we work on fish, they told us to throw away the waste where no on has trod."
    },
    "64": {
        "startTime": 522.184,
        "endTime": 528.017,
        "transcript": "Neqalleruar-gguq yuum qemirrlukngani caassiksunaituq.",
        "translation": "They said that a fish that a person [?] should not be [?]."
    },
    "65": {
        "startTime": 528.196,
        "endTime": 531.707,
        "transcript": "Assiiilkiurluta-llu neresqevkenata.",
        "translation": "They also told us not to dislike our food."
    },
    "66": {
        "startTime": 532.592,
        "endTime": 541.547,
        "transcript": "Tua-i-gguq neqa piilkan assiilkiurngaitukut, cangakiurngaitukut ilumun yuk kaikuni cangakingailami.",
        "translation": "They said that if there's no food, we will not dislike or reject anything, since a person truly will not reject anything if he's hungry."
    },
    "67": {
        "startTime": 541.813,
        "endTime": 544.729,
        "transcript": "Maa-i makut qanruyuteput.",
        "translation": "These are our traditional wisdom."
    },
    "68": {
        "startTime": 545.345,
        "endTime": 556.834,
        "transcript": "Tuamta-llu pitsaqevkenata-gguq aipangluta mikelngurmek aulukikumta",
        "translation": "Then, they said that should we marry and take care of a child"
    },
    "69": {
        "startTime": 558.314,
        "endTime": 568.802,
        "transcript": "Cali-gguq uumun aipamteńun angutmun cingucaqunaku. Tauna-gguq angun ayagatuuq, ayagayulriaruuq.",
        "translation": "They said we should not push him to our husband. They said that that man travels."
    },
    "70": {
        "startTime": 569.301,
        "endTime": 575.85,
        "transcript": "Taumek-gguq taumek mikelnguq cingutenrillaut taumun angutmun.",
        "translation": "That's why they said we shouldn't push that child to that man."
    },
    "71": {
        "startTime": 576.17,
        "endTime": 584.904,
        "transcript": "Tua-i-gguq kalivqinaqumta uamqerkauyaaqaa aipaqluku ikayuqerkaungamek nulirqelriik.",
        "translation": "They said that if we are in a bind, he must play with him to entertain him, since a couple should help each other."
    },
    "72": {
        "startTime": 585.653,
        "endTime": 590.908,
        "transcript": "Tau͡gaam-gguq ayagatulriaruuq. Auluku'urcetenrillaut.",
        "translation": "But they said he's a traveler. We shouldn't let him take care of the child."
    },
    "73": {
        "startTime": 591.109,
        "endTime": 600.92,
        "transcript": "Atam-gguq nacigatuniartuq. Ayagaqan atani tauna nacigayugluku assiinani.",
        "translation": "They said that he would be sad over his leaving. When his father leaves, he would be bad missing him."
    },
    "74": {
        "startTime": 601.907,
        "endTime": 614.129,
        "transcript": "Kiituani-gguq tua-i tua-i ayallermini-llu tayima kingutmun peng'garrluku ayagacurlautekciqaa nacigyukan.",
        "translation": "Eventually, they said that in his travels, he would be worried over him back home, and have bad travels if the child misses him."
    },
    "75": {
        "startTime": 614.255,
        "endTime": 624.244,
        "transcript": "Tua-i tuaten angutmun cingutesqevkenaku inerqutullruitkut irniangekumta irniarput.",
        "translation": "They would admonish us against pushing our child to the man like that if we have children."
    },
    "76": {
        "startTime": 624.953,
        "endTime": 638.419,
        "transcript": "Tuamtell' cali irniarput anglicaqumteggu tua-i-gguq enemi waniwa irniarput nayurluku aulukilriaruamta tautun angutetun ayagalriatun pivkenata.",
        "translation": "THen they said that when we raise our child, we will stay with our child in the house since we're the caretakers, unlike the men who travel."
    },
    "77": {
        "startTime": 638.747,
        "endTime": 645.399,
        "transcript": "Irniarput enem iluani murilkurararkaugarput-gguq.",
        "translation": "They said that we must watch our children in the house."
    },
    "78": {
        "startTime": 645.424,
        "endTime": 651.968,
        "transcript": "Inerciigatellra-llu-gguq anagulluku inerciigalucia pivkenaku.",
        "translation": "They also said not to react excessively when they misbehave."
    },
    "79": {
        "startTime": 652.002,
        "endTime": 658.769,
        "transcript": "Pingiinarqut-gguq inerciigataqameng anagulluki taqsuqupaka'arqaceteng.",
        "translation": "They said that they get worse when they react excessively when getting tired of their misbehavior."
    },
    "80": {
        "startTime": 658.78,
        "endTime": 669.047,
        "transcript": "Cali-llu-gguq erina nunutukumta, erinavut tapirviituq. Yagtaarpek'naku tauna irniarput, yagiravkenaku.",
        "translation": "They also said that if we scold them, that we don't need to add to our voices. We shouldn't raise a hand on our children."
    },
    "81": {
        "startTime": 669.14,
        "endTime": 672.484,
        "transcript": "Yagirakumteńi-gguq cacetuciquq.",
        "translation": "They said if we raise our hands on them, he'll be impertinent."
    },
    "82": {
        "startTime": 672.565,
        "endTime": 680.798,
        "transcript": "Cali-llu-gguq anagulluku qanpagapakaqumteńi cacetuluni. Tua-i-gguq cacetucararkaqerput tauna irniarput.",
        "translation": "They also said that if we excessively shout at him, he'll be impertinent. They said that we'll make our child impertinent."
    },
    "83": {
        "startTime": 681.253,
        "endTime": 686.197,
        "transcript": "Taumek-am call' qanruyuteput ilangqertut arnani.",
        "translation": "That's included in the traditional wisdom for women."
    },
    "84": {
        "startTime": 686.211,
        "endTime": 693.922,
        "transcript": "Tua-i-gguq tauna cacetucarciqerput wangkuta irniarput anagulluku qanpagaqu'rqumteggu.",
        "translation": "They said that we'll make our child impertinent if we excessively shout at him."
    },
    "85": {
        "startTime": 694.754,
        "endTime": 699.515,
        "transcript": "Tua-i niicuunani inerqungramteńi assiinani.",
        "translation": "He'll be bad and disobedient though we admonish him."
    },
    "86": {
        "startTime": 699.808,
        "endTime": 707.974,
        "transcript": "Cali-ll' inerciigalkan anagulluku call' inerciigatellra pivakaqumteńi arcariinarluni.",
        "translation": "Also, if he's mischievous and we react excessively, he will get worse."
    },
    "87": {
        "startTime": 708.796,
        "endTime": 714.307,
        "transcript": "Taumek-gguq qaruarrluku tau͡gaam mikelnguq piaqluku canrituq.",
        "translation": "That's why they said it's okay to encourage a child instead."
    },
    "88": {
        "startTime": 714.391,
        "endTime": 727.791,
        "transcript": "Tuamta-llu-gguq nunutukumta yuk tamarmi, yuk-gguq tamarmi eqneruuq. Tua-i-gguq irniani kenkerrlainayuutaa. Taqsuqnarqaqan nunutua.",
        "translation": "Then they said that if we scold, every person can be irritating. They said they don't always treat their children with love. They scold them when they get tiring."
    },
    "89": {
        "startTime": 727.888,
        "endTime": 731.093,
        "transcript": "Nunutukumta-gguq nunurciqerput.",
        "translation": "They said that if we scold, we will scold him."
    },
    "90": {
        "startTime": 731.187,
        "endTime": 735.72,
        "transcript": "Nunurraarluku-llu-gguq ngelaksugutevkenaku uitalluku.",
        "translation": "They said that after scolding him, do not laugh at him but leave him alone."
    },
    "91": {
        "startTime": 735.932,
        "endTime": 740.493,
        "transcript": "Tua-i uitalluku qanruteksaunaku nunuqumteggu.",
        "translation": "Leave him alone and don't say anything [else] if we scold him."
    },
    "92": {
        "startTime": 741.187,
        "endTime": 746.852,
        "transcript": "Tua-i assirikan tau͡gaam nutaan assirluku piluku nunurraarluku.",
        "translation": "Only when he gets better, treat him well after scolding him."
    },
    "93": {
        "startTime": 746.86,
        "endTime": 753.76,
        "transcript": "Qiakan tua-i tuaten engelallagatevkenaku-llu nunurraarluku.",
        "translation": "And if he cries, do not laugh at him after scolding him."
    },
    "94": {
        "startTime": 753.772,
        "endTime": 762.795,
        "transcript": "Engelallagaskumteńi-gguq cali assiiruciiquq. Engelallagacimalriit-gguq call' assiitaqut mikelnguut.",
        "translation": "They said that if we laugh at him, he will become bad. They say that children who are laughed at also become bad."
    },
    "95": {
        "startTime": 763.865,
        "endTime": 774.82,
        "transcript": "Tuaten-am call' mikelngurmek anglicarillerkamteńek enem iluani taumek aipirluku tamana tuaten pillerkarput.",
        "translation": "That is also included in what we should do when we raise children in the house."
    },
    "96": {
        "startTime": 775.534,
        "endTime": 782.556,
        "transcript": "Mikelnguum anglicallra qacignarqenrilami, anglicarturallra.",
        "translation": "It's because raising a child is not easy."
    },
    "97": {
        "startTime": 783.495,
        "endTime": 791.484,
        "transcript": "Makuggnaqluni. Wangkuta avani makugtellruukut anglicallemteńi irniaput.",
        "translation": "It's hard work. We worked hard to raise our children back then."
    },
    "98": {
        "startTime": 791.496,
        "endTime": 797.307,
        "transcript": "Mat'um-llu nalliinitun ayuqellrunritut irniaput anglicallemteńi",
        "translation": "And it wasn't like how it is now when we raised our children."
    },
    "99": {
        "startTime": 797.43,
        "endTime": 802.352,
        "transcript": "Terr'ilitarnek egciurluta pillrunritukut.",
        "translation": "We didn't have disposable diapers."
    },
    "100": {
        "startTime": 802.42,
        "endTime": 805.731,
        "transcript": "Taumek qanruyuteput amllellruut tua-i.",
        "translation": "That's why we had a lot of traditional wisdom."
    },
    "101": {
        "startTime": 805.805,
        "endTime": 816.25,
        "transcript": "Qavaryunqegkumta-llu teq'iciqniluta. Irniarput tauna tua-i aciminun qurrmarluni teq'iluta-llu. Teq'icugninaqluni.",
        "translation": "They said that if we sleep to much, we'll get urine on us. Our child will urinate on his bed and get it on us. It will smell like urine."
    },
    "102": {
        "startTime": 816.265,
        "endTime": 818.787,
        "transcript": "Maa-i assiryunqepialriaci.",
        "translation": "Now, you like to be very clean."
    },
    "103": {
        "startTime": 819.112,
        "endTime": 826.489,
        "transcript": "Tua-i-gguq qavaryunqegqumta enevut teq'icugninarqeciquq irniamta tepiinek",
        "translation": "They said that if we sleep too much, our house will smell like our child's urine"
    },
    "104": {
        "startTime": 826.789,
        "endTime": 830.028,
        "transcript": "Tua-i unugmi qurruciyuilamteńi.",
        "translation": "Because we don't have them urinate at night."
    },
    "105": {
        "startTime": 830.171,
        "endTime": 836.494,
        "transcript": "Irniaput qavamteńek makluta qurrucirluki qurrutaitnun qurrevkatullruaput unugmi.",
        "translation": "We would wake from our sleep, and have our children urinate in urine buckets at night."
    },
    "106": {
        "startTime": 836.529,
        "endTime": 841.329,
        "transcript": "Makcamta-llu qurrutii teguluku anluta ciqilluku.",
        "translation": "And when we got up, we'd take the urine container, go out, and dump it."
    },
    "107": {
        "startTime": 841.908,
        "endTime": 844.924,
        "transcript": "Iqairturyarat-wa terr'ilitait.",
        "translation": "They had diapers we'd need to wash."
    },
    "108": {
        "startTime": 844.935,
        "endTime": 856.824,
        "transcript": "Iqairturluki terr'ilitarkarugailata-llu terr'ilitarkaitelaata. Wanikuaqan iqairturluki pikalinrilngurni wangkuta terr'ilitait.",
        "translation": "We would always wash them since they didn't have a lot of diapers and would run out. We who didn't have a lot would wash their diapers later in the day."
    },
    "109": {
        "startTime": 857.338,
        "endTime": 867.183,
        "transcript": "Taumek tua-i tuaten qanruyutengqertukut calleruaraat murilkelluki pisqelluki.",
        "translation": "That's why we have that traditional wisdom, to look after little things."
    },
    "110": {
        "startTime": 870.568,
        "endTime": 876.328,
        "transcript": "Caunrilketalria-gguq caicu'gquq caunrilketaquni.",
        "translation": "They said that a person who doesn't care for things doesn't have anything."
    },
    "111": {
        "startTime": 876.367,
        "endTime": 879.278,
        "transcript": "Ca caunritniluku egtaqluku.",
        "translation": "He throws things away thinking their insignificant."
    },
    "112": {
        "startTime": 879.42,
        "endTime": 884.298,
        "transcript": "Ca-llu, cam-llu-gguq qemangqaurallra qiperrluyuituq-gguq.",
        "translation": "They also said that storing something does not [?]."
    },
    "113": {
        "startTime": 884.322,
        "endTime": 892.378,
        "transcript": "Atullerkaminun-gguq tekitetuuq natmun elliqerluku uitaurarqami, tua-i-llu-gguq atullerkaminun tekilluni.",
        "translation": "They said that the time to use it comes when they put and keep it, then the time to use it comes."
    },
    "114": {
        "startTime": 893.144,
        "endTime": 899.31,
        "transcript": "Tamaa-i tamakut qanruyutelput, wiinga-w' qanruyutellrenka ellangellemni.",
        "translation": "That is our traditional wisdom, at the traditional wisdom I grew up with."
    },
    "115": {
        "startTime": 899.389,
        "endTime": 905.078,
        "transcript": "Tua-i una call' waniw' kenka arcaqerluku qanruyutnguuq.",
        "translation": "Then this love is an important piece of traditional wisdom."
    },
    "116": {
        "startTime": 906.066,
        "endTime": 911.472,
        "transcript": "Ilamta pingraakut angu akinauresqevkenaku.",
        "translation": "No matter what our peer does to us, never retaliate."
    },
    "117": {
        "startTime": 911.543,
        "endTime": 919.02,
        "transcript": "Tuamtell' allaneruar tekiskan camiunguciilengraan ilaliuresqelluku.",
        "translation": "Then if a guest arrives, socialize with him even if you don't know where he's from."
    },
    "118": {
        "startTime": 919.034,
        "endTime": 921.456,
        "transcript": "Wii takartapiallruunga.",
        "translation": "I was very shy."
    },
    "119": {
        "startTime": 921.942,
        "endTime": 928.775,
        "transcript": "Caperqepiallruaqa man'a waten paiqatnga: \"Nutaan tangengerpegu ilaliuraqluku.",
        "translation": "I would be very daunted when they said this to me: \"Even if you see him for the first time, socialize with him."
    },
    "120": {
        "startTime": 928.842,
        "endTime": 940.064,
        "transcript": "\"Allaneq-llu nutaan tangengerpegu pikailkan qanrrarpenek ciuniurluku qanrrarpenek qalarulluku, wall' pikangqerkan nerqertelluku.\"",
        "translation": "\"And even if you see a guest for the first time, if there's none for him, welcome him by mouth, talking to him, or feed him if there's enough for him.\""
    },
    "121": {
        "startTime": 940.068,
        "endTime": 942.824,
        "transcript": "Takartapialrianga-wa wiinga.",
        "translation": "Here, I was very shy."
    },
    "122": {
        "startTime": 942.998,
        "endTime": 953.265,
        "transcript": "Tua-i-gguq tamaa-i tamana qanrraminek-llu ilaliurturluku wall'u nerqertelluku tungelqurturyaquq-gguq yuk.",
        "translation": "They said that socializing with a person by mouth or be feeding him, a person makes close friends."
    },
    "123": {
        "startTime": 953.28,
        "endTime": 957.869,
        "transcript": "Ilakliulluki tua-i tamakut ilaliuqallni.",
        "translation": "He becomes friends with those he socialized with."
    },
    "124": {
        "startTime": 957.882,
        "endTime": 964.793,
        "transcript": "Iliin-gguq yuum yuk-gguq caperrsugluni nunanun tekitetuuq, ilumuuluni-llu.",
        "translation": "They say that some people are daunted when arriving in a village, and it's true."
    },
    "125": {
        "startTime": 967.163,
        "endTime": 976.718,
        "transcript": "Tamaa-i tamakut qalaruyutek'lalput ilumun yugmun, yugnun tekitelleq caperrnarquq tekiteksailkeḿinun.",
        "translation": "Those things that they talked to us about are true, that it's difficult for a person to arrive where he's never gone before."
    },
    "126": {
        "startTime": 976.795,
        "endTime": 984.922,
        "transcript": "Taumek nallukvut nani tangeqsailkevut elluarrluku cali ciuniurarkaqliniarput.",
        "translation": "That's why we must give a hearty welcome to someone we don't know or haven't seen anywhere before."
    },
    "127": {
        "startTime": 985.23,
        "endTime": 994.808,
        "transcript": "Tua-i-gguq tauna caperrsugtuq ciunerkani nalluamiu. Ciunerkani nalluamiki capeqluki taukut nunat.",
        "translation": "They said that he's daunted because he doesn't know where he's going. He's daunted by that village because he doesn't know where he's going."
    },
    "128": {
        "startTime": 995.257,
        "endTime": 1002.168,
        "transcript": "Tua-i tuaten ayuquq. Ciunerkaput tekitaanrilkemteńun ayagaqamta caperrsutuukut.",
        "translation": "That's what it's like. When we go somewhere we've never been before, we're daunted."
    },
    "129": {
        "startTime": 1002.513,
        "endTime": 1007.306,
        "transcript": "Taumek maa-i man'a ayagyuani elpeci umyuaqerkarci.",
        "translation": "That's why you young people should remember this."
    },
    "130": {
        "startTime": 1007.317,
        "endTime": 1016.528,
        "transcript": "Cali-llu ilarraci, ilavci pingraiceci angu pillruniluci piqaqsaunaki.",
        "translation": "Also, no matter what your peers do to you, never do anything because they did something to you."
    },
    "131": {
        "startTime": 1016.539,
        "endTime": 1023.905,
        "transcript": "Cali-llu angayuqaput qigcikesqelluki qanrucimatullruukut.",
        "translation": "We were also told to respect our parents."
    },
    "132": {
        "startTime": 1024.083,
        "endTime": 1029.528,
        "transcript": "Taumek angayuqertuumalriani cali maa-i makut qanruyutellrenka.",
        "translation": "That's why to you who still have parents, this is the traditional wisdom passed down to me."
    },
    "133": {
        "startTime": 1029.601,
        "endTime": 1038.434,
        "transcript": "Angayuqaput takaqerkauluki, qigcikluki, qanruyukariit-llu maligtaqungnaqluku.",
        "translation": "We must defer to and respect our parents, and try to adhere to their traditional wisdom."
    },
    "134": {
        "startTime": 1038.511,
        "endTime": 1041.911,
        "transcript": "Tuaten qanrucimallruukut wangkuta.",
        "translation": "That's what we were told."
    },
    "135": {
        "startTime": 1041.931,
        "endTime": 1045.975,
        "transcript": "Taumek anglicarteput qigcignarqellruut.",
        "translation": "THat's why we had to respect those who raised us."
    },
    "136": {
        "startTime": 1047.315,
        "endTime": 1052.482,
        "transcript": "Maa-i makut wii ellangellemni qanruyutellrenka.",
        "translation": "THis is the traditional wisdom passed down to me when I was growing up."
    },
    "137": {
        "startTime": 1052.745,
        "endTime": 1062.382,
        "transcript": "Qanruyuteput tang, Yuum qanruyutii amllepialria. Tua-i ca tamarmi qanruyutetarluni.",
        "translation": "There is a lot of our traditional wisdom, Yup'ik wisdom. There's traditional wisdom for everything."
    },
    "138": {
        "startTime": 1063.344,
        "endTime": 1069.978,
        "transcript": "Qanrutketukumteki qanrumalaryartukut. Ca tamarmi qanruyutengqertuq.",
        "translation": "If we talked about them, we'd talk for a long time. There's traditional wisdom for everything."
    },
    "139": {
        "startTime": 1070.045,
        "endTime": 1078.901,
        "transcript": "Maa-i makut arcaqerluki wii qanruyutellrenka tamakut tamaa-i neqalleruaraam murilkellerkaa.",
        "translation": "These are the important traditional wisdom passed down to me, looking after fish."
    },
    "140": {
        "startTime": 1078.912,
        "endTime": 1089.023,
        "transcript": "Cali-ll' tua-i ilamta pingraakut kenekluki, kia-ll' pingraakut akinauyuunaku pillerkarput.",
        "translation": "And to treat our peers with love no matter what they do to us, and not to retaliate no matter what someone does to us."
    },
    "141": {
        "startTime": 1090.87,
        "endTime": 1097.393,
        "transcript": "Tuaten-llu tua-i mikelngurmek call' anglicarikumta tuaten auluklerkaa.",
        "translation": "And how to take care of a child if we raise him."
    },
    "142": {
        "startTime": 1098.804,
        "endTime": 1100.993,
        "transcript": "Camek?",
        "translation": "What else?"
    },
    "143": {
        "startTime": 1104.934,
        "endTime": 1107.304,
        "transcript": "Paiciulluta?",
        "translation": "Leaving us a legacy?"
    },
    "144": {
        "startTime": 1107.594,
        "endTime": 1120.334,
        "transcript": "Tutgaramni elpeci paiciryaramci nang'arkaunrilngurmek umyuaqekuvciu, paiciryaramci qanruyutmek.",
        "translation": "I would leave you, my grandchildren, with something that will never end if you remember it, I would leave you with traditional wisdom."
    },
    "145": {
        "startTime": 1122.289,
        "endTime": 1128.179,
        "transcript": "Waniw' qanertua ava-i, \"Ilaci kenkarkaugaci.\"",
        "translation": "I just said now, \"You must treat those around you with love.\""
    },
    "146": {
        "startTime": 1128.319,
        "endTime": 1138.329,
        "transcript": "Kia pingraaci kenekluki. Kitumun-llu pilarniluci tauna piksaunaku tau͡gaam ayuqluku kenekluki.",
        "translation": "No matter what anyone does to you, treat them with love. And do not do anything if they do something to you, but love them all the same."
    },
    "147": {
        "startTime": 1139.239,
        "endTime": 1143.509,
        "transcript": "Tamaa-i paiciutekarci maa-i man'a kenka.",
        "translation": "This love is to be your bequest."
    },
    "148": {
        "startTime": 1143.939,
        "endTime": 1151.039,
        "transcript": "Tua-i-llu ilaci kenekluki, Agayutsi-llu cacetuqutekluku.",
        "translation": "Then, love those around you, and depend on your God."
    },
    "149": {
        "startTime": 1151.174,
        "endTime": 1155.574,
        "transcript": "Tamaa-i paiciutekaqaqa elpeceńun tutgaramnun.",
        "translation": "That is what I bequeath to you, my grandchildren."
    },
    "150": {
        "startTime": 1155.699,
        "endTime": 1170.187,
        "transcript": "Tua-i-ll' kankut tutgaraanka, ilaci kankut qanrut'laranka ertet tamaklaita ayuqucirturluki paitaqesqessaaqluku qanruyun.",
        "translation": "Then my grandchildren down there, your relatives, I tell them at the dawn of every day to teach them, so that they will inherit the traditional wisdom."
    },
    "151": {
        "startTime": 1170.287,
        "endTime": 1176.5,
        "transcript": "Maaken ayange'rma tangenrring'erpecia umyuaqelaasqessaaqluku.",
        "translation": "So that you will remember it though I leave this place and you no longer see me."
    },
    "152": {
        "startTime": 1176.574,
        "endTime": 1192.587,
        "transcript": "Qanrut'laranka ertet tamaklaita qaillun ilaita anelgukarait-llu kenekluki pisqelluki, wall'u anelgutkenrilengraitki, wall'u ilaita pingraita akinauyuitesqelluki.",
        "translation": "I tell them at the dawn of every day to treat their peers and what siblings thye have with love, of even if they're not siblings, or not to retaliate no matter what their peers do to them."
    },
    "153": {
        "startTime": 1192.762,
        "endTime": 1202.712,
        "transcript": "Cali-llu qanleravkenaki pisqelluki, iciw' tua-i qanqataitesqevkenaci.",
        "translation": "I also tell them not to speak harshly, you know, not to speak without thinking."
    },
    "154": {
        "startTime": 1202.744,
        "endTime": 1208.981,
        "transcript": "Qanqatailkuvci umyuarniutmun tekitelarciquci.",
        "translation": "If you speak without thinking, you will come to regretful times."
    },
    "155": {
        "startTime": 1209.019,
        "endTime": 1214.156,
        "transcript": "Tamaa-i taman' paiciutekaqa umyuaqelararkarci.",
        "translation": "That is my bequest that you must remember."
    },
    "156": {
        "startTime": 1215.719,
        "endTime": 1223.306,
        "transcript": "Maaken ayange'rma tua-i umyuaqelararkauluku elpeci, tua-i paitaqluku.",
        "translation": "Though I leave this place, you must remember it, as an inheritance."
    },
    "157": {
        "startTime": 1229.369,
        "endTime": 1231.969,
        "transcript": "Iciw' qessanquuyaram tungiinun.",
        "translation": "You know, about being lazy."
    },
    "158": {
        "startTime": 1236.238,
        "endTime": 1247.976,
        "transcript": "Qessanqurrukuni yuk, yuk-gguq waten-am call' qanrutetuitkut:",
        "translation": "If a person is lazy, they also tell us this:"
    },
    "159": {
        "startTime": 1252.476,
        "endTime": 1259.551,
        "transcript": "\"Yuk-gguq qessailngurmek ilaituq. Qessanqurruuq-gguq yuk tamarmi.",
        "translation": "\"There is no one without a lazy inclination. Every person is lazy [sometimes]."
    },
    "160": {
        "startTime": 1260.182,
        "endTime": 1268.77,
        "transcript": "\"Tau͡gaam-gguq qessani ayimqelluku yuulriim qessang'ermi piaqluni qessailngurmek aprumaciquq.",
        "translation": "\"But if a person lives by 'breaking' his laziness and does things in spite of his laziness will be called one who is not lazy."
    },
    "161": {
        "startTime": 1268.783,
        "endTime": 1275.133,
        "transcript": "\"Tau͡gken-gguq qessallni maligtaquluku uitayulria tua-i qessanqurruluni.\"",
        "translation": "\"However, a person who follows his laziness and is sedentary is lazy.\""
    },
    "162": {
        "startTime": 1275.177,
        "endTime": 1286.89,
        "transcript": "Ilumun qessang'ermi pilleq, qessange'rmi tua-i piluni ca piaqluku qessange'rmi kiituan tengrunguq.",
        "translation": "Truly, someone who does things in spite of laziness, who does things without laziness, eventually becomes eager."
    },
    "163": {
        "startTime": 1288.89,
        "endTime": 1302.09,
        "transcript": "Kiituan caarkaminek eneqangcanguq, caarkani-ll' nallunrirluki, kevgiurarkani nallunrirluki, qanrutkenrilengraitki-llu nallunrirluki tua-i pilaamiki.",
        "translation": "Eventually, he remembers his chores, and knows what he needs to do, knows how he needs to serve, and knows them despite not being told because he does them."
    },
    "164": {
        "startTime": 1302.784,
        "endTime": 1307.984,
        "transcript": "Makut pitukni nallunrirluki, tua-i calliuryarat nallunrirluki.",
        "translation": "He knows what he does, and knows how to do things."
    },
    "165": {
        "startTime": 1308.253,
        "endTime": 1312.778,
        "transcript": "Tamaa-i qessailnguum, tuaten ayuquq qessailnguq.",
        "translation": "That's what a person who's not lazy is like."
    },
    "166": {
        "startTime": 1313.084,
        "endTime": 1323.959,
        "transcript": "Tua-i pilaamiki, qessange'rmi pilaamiki nallunrirluki. Tua-i-ll' qessange'rmi yagqaarluni qessanrirluni, kiituan tengrunguq.",
        "translation": "He knows them because he does them despite his laziness. Then even when he's lazy, he raises his hand, is no longer lazy, and is eventually eager."
    },
    "167": {
        "startTime": 1324.715,
        "endTime": 1332.728,
        "transcript": "Tua-i piyugteqengluni, piyugturangluni, cayugturangluni tua-i. Tamaa-i qessaicaram ayuqucia.",
        "translation": "He starts wanting to do things, wanting to do things, doing chores. That's what someone' who's not lazy is like."
    },
    "168": {
        "startTime": 1332.74,
        "endTime": 1337.29,
        "transcript": "Caarkaminek eneqangcarturangluni caarkani nallunrirluki.",
        "translation": "He starts thinking of his chores, knowing his chores."
    },
    "169": {
        "startTime": 1337.472,
        "endTime": 1347.947,
        "transcript": "Tau͡gken qessayulria tua-i qessallni maligtaquluku uitiimi tua-i caarkani nallunrilngermiki qessaluni tua-i.",
        "translation": "Yet since a lazy person follows his laziness and is sedentary, though he knows what he needs to do, he's lazy."
    },
    "170": {
        "startTime": 1348.003,
        "endTime": 1355.253,
        "transcript": "Tamaa-i-gguq tamana tuaten qessallni maligtaqustii qessanqumek aprumatuuq.",
        "translation": "They say that one who follows is laziness like that is called a qessanquq."
    },
    "171": {
        "startTime": 1355.272,
        "endTime": 1362.472,
        "transcript": "Tau͡gken-gguq qessailnguq, waten pituitkut-am cali: \"Yuk-gguq qessailngurmek ilaituq.",
        "translation": "Yet one who is not lazy, they also tell us this: \"There is no person completely without laziness."
    },
    "172": {
        "startTime": 1364.166,
        "endTime": 1372.316,
        "transcript": "\"Tua-i-gguq tau͡gaam qessallni ayimqelluku yuulria qessange'rmi piaqluni qessailngurmek aprumauq.\"",
        "translation": "But one who lives by 'breaking' his laziness and does things in spite of his laziness is called one who is not lazy.\""
    },
    "173": {
        "startTime": 1372.335,
        "endTime": 1382.073,
        "transcript": "Ilumuuguq tamana tua-i qessange'rmi piluni tua-i-ll' caarkani nallunrirluiki, piarkani nallunrirluni.",
        "translation": "That's true, that if he does things in spite of his laziness, he'll know his chores, know what he needs to do."
    },
    "174": {
        "startTime": 1382.273,
        "endTime": 1386.198,
        "transcript": "Caarkani tua-i nallunrirluki kevgartuagarkani.",
        "translation": "He knows the chores he needs to do for others."
    },
    "175": {
        "startTime": 1386.204,
        "endTime": 1393.142,
        "transcript": "Cat-llu makut maa-i kenagqurangekci. Kenagtarkani qessanrirciqai tengrukengluki.",
        "translation": "You also like to clean things. He'll no longer be lazy to clean, but become eager."
    },
    "176": {
        "startTime": 1393.855,
        "endTime": 1398.867,
        "transcript": "Ca tamarmi maa-i kenagqurangelriaci.",
        "translation": "Now, you clean everything."
    },
    "177": {
        "startTime": 1398.93,
        "endTime": 1403.943,
        "transcript": "Tua-i tuaten ellirluni tengrukengluki caarkani.",
        "translation": "He'll become like that, eager to do his chores."
    },
    "178": {
        "startTime": 1403.955,
        "endTime": 1410.78,
        "transcript": "Tau͡gken qessaluni uitakuni, tua-i ilalcirluni uitaluni qessallni maligtaquluku.",
        "translation": "Yet if he's sedentary out of laziness, he puts up with being sedentary following his laziness."
    },
    "179": {
        "startTime": 1410.911,
        "endTime": 1418.049,
        "transcript": "Tua-i-gguq tauna tuaten qessani maligtaqustii qessanqumek apaamaarkaurtelartuq.",
        "translation": "They say that one who obeys his laziness will start to be called a qessanquq."
    },
    "180": {
        "startTime": 1418.224,
        "endTime": 1427.724,
        "transcript": "Tuamtell' waniw' una cali qanruyutek'laqngaqa kankunun arcaqerluku ilavnun kankunun tutgaramnun:",
        "translation": "Then, this is the wisdom I pass down especially to your relatives down there, my grandchildren down there:"
    },
    "181": {
        "startTime": 1428.731,
        "endTime": 1437.093,
        "transcript": "\"Yuk qenngailngurmek ilaituq. Cakegtaunrilnge'rmi yuk tamarmi qenngauq.\"",
        "translation": "\"There's no person completely without anger. Every person, even if he's not great, gets angry.\""
    },
    "182": {
        "startTime": 1437.131,
        "endTime": 1446.256,
        "transcript": "Wii waniw' cakegtaunricaaqua tua-i, yuk'egtauvkenii cakegtauvkenii, amta-ll' tang qenqercuglua, qenqertellerkaqa wantaurluni.",
        "translation": "I'm not great, not a good or great person, yet I am easily angered, my inclination to become angry right here."
    },
    "183": {
        "startTime": 1446.275,
        "endTime": 1450.2,
        "transcript": "Tua-i ilumun qenqertellerkaqa wantarluni.",
        "translation": "Indeed, my inclination to get angry is right here."
    },
    "184": {
        "startTime": 1450.294,
        "endTime": 1458.556,
        "transcript": "Taumek yuum ucngalutekenrilliu qenngacini. Yuum tamarmi cakegtaunrilnge'rmi tua-i aturaa.",
        "translation": "That's why a person shouldn't be proud of being angry. Every person, even if they're not great, experiences it."
    },
    "185": {
        "startTime": 1459.182,
        "endTime": 1464.007,
        "transcript": "Qennganitekluni cali qenngacini piyunaitaa.",
        "translation": "He also shouldn't be easily angered because he's angered easily."
    },
    "186": {
        "startTime": 1464.038,
        "endTime": 1469.451,
        "transcript": "Cam iliiniku unguvamta iquani aturngaitarput qennga.",
        "translation": "Someday at the end of our life, we will not experience anger."
    },
    "187": {
        "startTime": 1470.776,
        "endTime": 1480.188,
        "transcript": "Tua-i tau͡gaam waniw'-am cali iqukelaqengaqa kankunun: \"Qenqerrluta anirtuumallerkamteńun ayalerngaitukut.\"",
        "translation": "I end it with this to them down there: \"We will not progress to salvation through anger.\""
    },
    "188": {
        "startTime": 1480.739,
        "endTime": 1492.276,
        "transcript": "Maa-i man'a paiciutekaqaqa. Elpet paiciutekaqluku. Elpeceńun qanruyutek'larqa kankunun, \"Qenqerrluta unguvamun ayagarrngaitukut.\"",
        "translation": "This is what I bequeath. You shall inherit it. I pass on this wisdom to you down there, \"We will not prgress to life through anger.\""
    },
    "189": {
        "startTime": 1494.864,
        "endTime": 1511.151,
        "transcript": "Tuavet assiilngurmun piqataqakut atanrem, egteqataqakut qenqerrluta tuavet ayagarrngaitukut waten piluta: \"Wii-w' tuańngailngua qenngiima.\" Tuaten pingaitukut.",
        "translation": "When the lord is going to throw us into that bad place, we will not go there saying this: \"I won't go there because I'm angry.\" We won't say that."
    },
    "190": {
        "startTime": 1511.476,
        "endTime": 1520.939,
        "transcript": "Wii man'a tua-i qenqerculaama umyuaqela'arqa qenngaciqa tuani unguvamta iquani atuungailucia.",
        "translation": "Because I am easily angered, I remember that we will not experience my anger there at the end of our life."
    },
    "191": {
        "startTime": 1520.951,
        "endTime": 1525.526,
        "transcript": "Taumek umyuaqaqluku qenqerculriani pinaurtukut.",
        "translation": "So, let us who are easily angered remember it."
    },
    "192": {
        "startTime": 1526.282,
        "endTime": 1533.42,
        "transcript": "Maa-i tua-i umyuaqelararkaci. Qenqerteng'e'rpeci tuaten umyuarteqaqluci.",
        "translation": "This is what you must remember. Even if you're easily angered, think like that."
    },
    "193": {
        "startTime": 1533.433,
        "endTime": 1542.02,
        "transcript": "Cali-ll' tua-i tamaa-i qessayullerpeci ayuqucia, qessayullrem maligtaqullra.",
        "translation": "Also, what it's like for you to be lazy, to obey laziness."
    },
    "194": {
        "startTime": 1543.17,
        "endTime": 1549.67,
        "transcript": "Qessange'rmi tau͡gken piqcaaralleq tua-i cali piqcaarnarquq qessange'rmi.",
        "translation": "Yet doing things in spite of laziness makes you keep doing it in spite of laziness."
    },
    "195": {
        "startTime": 1549.789,
        "endTime": 1560.439,
        "transcript": "Call' caperqepiarraarluku, cat-llu neqet amllerqata caperqepiaryaaqerraarluki tua-i piqtarturalriani nangluteng tua-i.",
        "translation": "Also, after being very daunted, even after being daunted by [preparing] a lot of food, they are finished with continued work."
    },
    "196": {
        "startTime": 1560.646,
        "endTime": 1569.233,
        "transcript": "Cali-ll' akluarait tua-i makut caalleruarait cagtenritengnaqluki amllengrraata piqcaarturluki tua-i kiituan nang'ut.",
        "translation": "Also, try not to keep whatever articles of clothing in a mess, because when they're worked on even if they're a lot, they're eventually finished."
    },
    "197": {
        "startTime": 1569.321,
        "endTime": 1577.821,
        "transcript": "Paralqepailgateng-llu tua-i nangluteng qessange'rmi piqtarturluki, apqiitnek qessamun puukarpailegmeng.",
        "translation": "Then before they're infested with worms, they're finished when worked on in spite of laziness, before they \"bump into laziness\" as they call it."
    },
    "198": {
        "startTime": 1578.453,
        "endTime": 1583.34,
        "transcript": "Tua-i tuaten qessayaraq ayuquq.",
        "translation": "That's what being lazy is like."
    },
    "199": {
        "startTime": 1583.778,
        "endTime": 1590.14,
        "transcript": "Caurailngautnguuq-llu-gguq piilngautnguluni-llu qessaneq.",
        "translation": "They also say that laziness makes one have nothing, and makes them lack things."
    },
    "200": {
        "startTime": 1590.728,
        "endTime": 1595.041,
        "transcript": "Tamaa-i tua-i taman' qessayaraq tuaten ayuquq.",
        "translation": "That's what being lazy is like."
    },
    "201": {
        "startTime": 1596.766,
        "endTime": 1603.103,
        "transcript": "Tua-i call' camek apeskuvnga kiuyugngakumku kiuciqaqa, kiusciigalkumku-ll' kiuvkenaku.",
        "translation": "So if you ask me anything else, I will answer if I can, but will not answer if I can't."
    },
    "202": {
        "startTime": 1604.853,
        "endTime": 1605.678,
        "transcript": "Ii-i.",
        "translation": "Yes."
    }
};